import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar'
import zeeepy_logo from '../assets/images/zeeepy_logo.jpg';
import {Link} from 'react-router-dom';

const TopNavbar = () => {
  return (
    <>
    <div className={"top-nav-bar"}>
      <Navbar bg="light" expand="lg">
        <Container fluid>
          <Navbar.Brand href="#home">
            <img className='logo' src={zeeepy_logo} alt='Zeeepy Logo' />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-right">
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="about">About</Nav.Link>
              <Nav.Link href="/#services">Services</Nav.Link>
              <Nav.Link href="languages">Languages</Nav.Link>
              <Nav.Link href="testimonials">Testimonials</Nav.Link>
              <Nav.Link href="contact">Contact</Nav.Link>
              
              <Nav.Link style={{width: "120px"}}></Nav.Link>
              
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className='get-quote'>
        <p><a href="/#pricing">Get Quote</a></p>
      </div>
    </div>
    
    </>
  )
}

export default TopNavbar;